import { render, staticRenderFns } from "./ClipboardPlusIcon.vue?vue&type=template&id=9ddef6d8"
import script from "./ClipboardPlusIcon.vue?vue&type=script&lang=js"
export * from "./ClipboardPlusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports